import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { ConfigService } from 'src/app/services/core/config/config.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()
@Component({
  selector: 'app-add-configuration',
  templateUrl: './add-configuration.component.html',
  styleUrls: ['./add-configuration.component.css']
})
export class AddConfigurationComponent implements OnInit {
 configForm!: FormGroup;
   configId :any;
   submitted = false;
   companyId: any;
   user: any;
   companyWiseConfiguration: any;
 
   constructor(private fb: FormBuilder, private route: ActivatedRoute, private router: Router,private configService: ConfigService,
    private sharedDataService:SharedDataService
   ){
 
   }
 
   ngOnInit(){
    this.getUser();
      this.companyId = this.route.snapshot.params['companyId'];
      this.configId = this.route.snapshot.params['configId'];

     this.configForm = this.fb.group({
       reference: ['', Validators.required],
       generalUrl: ['', Validators.required],
       tripUrl: ['', Validators.required],
       vehicleUrl: [''],
       driverUrl: [''],
      //  quickbooks:this.fb.group({
      //   username: [''],
      //   password: [''],
      //   url:['']
      //  }),
       company:[this.companyId],
       user:[this.user.id],
       isActive: [false],
       isAllowEmail : [true]
     })
       this.getConfigurationbyId();

   }


    getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe(data => {
      if (data) {
        this.user = data;
      }
    })
  }

getConfigurationbyId() {
  this.configService.getConfigByCompanyWise(this.companyId)
    .pipe(untilDestroyed(this))
    .subscribe((data: any) => {
      if (data) {
        this.configId = data._id
        this.companyWiseConfiguration = data
        this.configForm.patchValue({
          ...data
        });
      }
    });
  }
 
  onSave() {
    this.submitted = true;
    if (this.configForm.invalid) return;

    const payload = this.configForm.value;

    this.configService.save(this.configId, payload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.router.navigate(['/credentials'], { state: { selectedItem: history.state.status } });
          }
        },
        error: (err: any) => {
          sweetAlert("Error", err, "error", "OK");
        }
      });
  }

   get form(){
     return this.configForm.controls;
   }
 
}
